<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
    <path
      stroke="currentColor"
      stroke-miterlimit="10"
      stroke-width="2"
      fill="none"
      d="M18.06 15.88a3.94 3.94 0 1 0 0-7.88 3.94 3.94 0 0 0 0 7.88ZM3.6 13.52a1.6 1.6 0 1 0 0-3.18 1.6 1.6 0 0 0 0 3.18ZM3.5 10.32l13.7-2.27M3.7 13.6l13.62 2.18"
    />
  </svg>
</template>
<script>
export default {};
</script>
